import { EmploymentHistoryEntryState, EmploymentHistoryEntryAction, EmploymentSubQuestion } from './EmploymentHistoryEntryContext'
import { areEmployerDetailsRequired } from '../EmploymentStatus/EmploymentStatusOptions'

const getNextQuestion = (
  currentQuestion: EmploymentSubQuestion,
  employmentSituation: string | undefined
): EmploymentSubQuestion | undefined => {
  switch (currentQuestion) {
    case 'SITUATION':
      return areEmployerDetailsRequired(employmentSituation)
        ? 'EMPLOYER_DETAILS'
        : 'TIME_IN_SITUATION'
    case 'EMPLOYER_DETAILS':
      return 'TIME_IN_SITUATION'
    case 'TIME_IN_SITUATION':
    default:
      return undefined
  }
}

const getPreviousQuestion = (
  currentQuestion: EmploymentSubQuestion,
  employmentSituation: string | undefined
): EmploymentSubQuestion | undefined => {
  switch (currentQuestion) {
    case 'SITUATION':
      return undefined
    case 'EMPLOYER_DETAILS':
      return 'SITUATION'
    case 'TIME_IN_SITUATION':
      return areEmployerDetailsRequired(employmentSituation)
        ? 'EMPLOYER_DETAILS'
        : 'SITUATION'
    default:
      return undefined
  }
}

const EmploymentHistoryEntryReducer = () => (
  previousState: EmploymentHistoryEntryState,
  action: EmploymentHistoryEntryAction
): EmploymentHistoryEntryState => {
  switch (action.type) {
    case 'NEXT': {
      const nextQuestion = getNextQuestion(
        previousState.question,
        previousState.entry.employmentSituation
      )

      if (nextQuestion === undefined) {
        return {
          ...previousState,
          escapeAction: 'NEXT'
        }
      }
      return {
        ...previousState,
        escapeAction: undefined,
        question: nextQuestion
      }
    }
    case 'PREVIOUS': {
      const previousQuestion = getPreviousQuestion(
        previousState.question,
        previousState.entry.employmentSituation
      )

      if (previousQuestion === undefined) {
        return {
          ...previousState,
          escapeAction: 'PREVIOUS'
        }
      }
      return {
        ...previousState,
        escapeAction: undefined,
        question: previousQuestion
      }
    }
    case 'UPDATE_STATUS': {
      const hasChangedNeedingEmployerDetails = (
        areEmployerDetailsRequired(previousState.entry.employmentSituation) !== areEmployerDetailsRequired(action.value)
      )
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          employmentSituation: action.value,
          employerDetails: hasChangedNeedingEmployerDetails ? undefined : previousState.entry.employerDetails,
          lengthOfTime: hasChangedNeedingEmployerDetails ? undefined : previousState.entry.lengthOfTime
        }
      }
    }
    case 'UPDATE_EMPLOYER_DETAILS': {
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          employerDetails: {
            jobTitle: action.value.jobTitle,
            companyName: action.value.companyName,
            location: action.value.location
          }
        }
      }
    }
    case 'UPDATE_TIME_IN_SITUATION': {
      return {
        ...previousState,
        entry: {
          ...previousState.entry,
          lengthOfTime: action.value
        }
      }
    }
    default: {
      return previousState
    }
  }
}

export default EmploymentHistoryEntryReducer
